import { trackEvent } from './analytics';

/**
 * Utility function to track user interactions throughout the application
 * 
 * @param {string} category - The category of the interaction (e.g., 'Survey', 'Question', 'Dashboard')
 * @param {string} action - The action performed (e.g., 'Create', 'Edit', 'Delete', 'View')
 * @param {string} label - Optional label for additional context
 * @param {object} additionalData - Optional additional data to include with the event
 */
const trackUserInteraction = (category, action, label = '', additionalData = {}) => {
  // Only track if the user is logged in
  const isLoggedIn = localStorage.getItem('token');
  if (!isLoggedIn) return;

  // Construct the event name
  const eventName = `${category}_${action}`;
  
  // Get basic user info from localStorage
  let user = {};
  try {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      user = JSON.parse(userJson);
    }
  } catch (error) {
    console.error('Error parsing user data for analytics:', error);
  }
  
  // Get basic customer info from localStorage
  let customer = {};
  try {
    const customerJson = localStorage.getItem('customer');
    if (customerJson) {
      customer = JSON.parse(customerJson);
    }
  } catch (error) {
    console.error('Error parsing customer data for analytics:', error);
  }
  
  // Track the event with combined properties
  trackEvent(eventName, {
    category,
    action,
    label,
    userId: user.email || '',
    schoolId: user.schoolId || customer.id || 0,
    matId: user.matGroupId || (customer.customerType === 'MAT' ? customer.id : 0),
    customerType: customer.customerType || '',
    ...additionalData
  });
};

export default trackUserInteraction;